"use strict";

function display_image(className, src, title, alt) {
  var figure = document.querySelector('.art__figure');
  var img = document.createElement("img");
  img.className = className;
  img.src = src;
  img.title = title;
  img.alt = alt;
  figure.appendChild(img);
}

display_image('art__img', './assets/img/banner.png', 'Ilustração da natureza e sua beleza', 'JavaScriptImage');

for (var i = 0; i < 2; i++) {
  var secOne = document.querySelector('.sec-one');
  var secContainer = document.querySelector('.sec-one__container');
  var elementoClone = secContainer.cloneNode(true);
  secOne.appendChild(elementoClone);
}